import script from "./FAQLacen.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQLacen.vue?vue&type=script&setup=true&lang=js"

import "./FAQLacen.vue?vue&type=style&index=0&id=41da4c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41da4c36"]])

export default __exports__